export default "__VITE_ASSET__b0AR5V8T__"